<template>
    <div class="time-ticker-wrapper">
        <div class="time-ticker">
            <span class="date">{{ formattedDate }}</span>
            <span class="time">{{ formattedTime }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { formatTime, formatDate } from '@/widgets/Wizard/modules/formatting';

const i18n = useI18n();
const date = ref(new Date());
const interval = ref();

const formattedDate = computed(() => {
    return formatDate(date.value, i18n);
});

const formattedTime = computed(() => {
    return formatTime(date.value);
});

onMounted(() => {
    interval.value = setInterval(() => {
        date.value = new Date();
    }, 1000);
});

onUnmounted(() => {
    clearInterval(interval.value);
});
</script>
